export const ISFRONTEND = 'ISFRONTEND'
export const CHANGEUSER = 'CHANGEUSER'
export const SLIDEDRAWER = 'SLIDEDRAWER'
export const REPORTDATA = 'REPORTDATA' 